import { render } from "./GroupPage.vue?vue&type=template&id=0c4e98fd"
import script from "./GroupPage.vue?vue&type=script&lang=js"
export * from "./GroupPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__